import { authSelectors } from '@redux/auth';
import { useAppSelector } from '@redux/hooks';

import { isStatusFailedAny } from '@utils';
import { useLocation } from 'react-router-dom';
import { matchPath } from 'react-router-dom';
import { ApiStatus, AppRoutes } from '@constants';
import { useIsStandalonePage } from './useIsStandalonePage';

export const useAppIsLoading = () => {
  const { apiStatus } = useAppSelector(authSelectors.getProfileAPIData);

  const location = useLocation();
  const isStandalonePage = useIsStandalonePage();

  // For standalone pages, we don't need to show the loading state, since no profile is loaded
  if (isStandalonePage) {
    return false;
  }

  // For non-standalone pages
  return (
    // If the profile is loading
    apiStatus === ApiStatus.LOADING ||
    // If it's the very first render of the app
    apiStatus === ApiStatus.IDLE ||
    // Few  frames for when /profile was fetched with error and failed, but redirect didnt finish yet
    (isStatusFailedAny(apiStatus) &&
      !matchPath(AppRoutes.SIGN_IN, location.pathname))
  );
};
